/**
 * Component - whereToUseBlock
 */

export const whereToUseBlock = ():void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-whereToUseBlock') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {
  })
}
